import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { apiGet } from "./client.js";

export function useHealth() {
  return useQuery({ queryKey: ["health"], queryFn: ({ signal }) => apiGet("/health", { signal }), staleTime: 60_000 });
}

export function useTenants() {
  return useQuery({
    queryKey: ["tenants"],
    queryFn: ({ signal }) => apiGet("/tenants", { signal }),
    staleTime: 30 * 60_000,
  });
}

export function useFilterOptions(tenant, from, to) {
  return useQuery({
    queryKey: ["filter-options", tenant, from, to],
    queryFn: ({ signal }) => apiGet(`/filter-options?${new URLSearchParams({ tenant, from, to })}`, { signal }),
    staleTime: 30 * 60_000,
    enabled: Boolean(tenant),
  });
}

/** One tab's report. `qs` is the API query string built by useFilters. */
export function useReport(dashboard, tab, qs) {
  return useQuery({
    queryKey: ["report", dashboard, tab, qs],
    queryFn: ({ signal }) => apiGet(`/report/${dashboard}/${tab}?${qs}`, { signal }),
    placeholderData: keepPreviousData,
  });
}

/** Drill-down analytics for one content item. */
export function useContent(type, id, qs) {
  return useQuery({
    queryKey: ["content", type, id, qs],
    queryFn: ({ signal }) => apiGet(`/content/${type}/${id}?${qs}`, { signal }),
    placeholderData: keepPreviousData,
  });
}

/** One user's profile and activity (internal only). */
export function useUser(uid, qs) {
  return useQuery({
    queryKey: ["user", uid, qs],
    queryFn: ({ signal }) => apiGet(`/user/${uid}?${qs}`, { signal }),
    placeholderData: keepPreviousData,
  });
}

export function useRaw(page, qs) {
  return useQuery({
    queryKey: ["raw", page, qs],
    queryFn: ({ signal }) => apiGet(`/raw/${page}?${qs}`, { signal }),
    placeholderData: keepPreviousData,
  });
}

/** Signed-in user, their allowed tenants, and their permissions for `tenant`. */
export function useMe(tenant) {
  return useQuery({
    queryKey: ["me", tenant],
    queryFn: ({ signal }) => apiGet(`/auth/me?${new URLSearchParams({ tenant: tenant || "" })}`, { signal }),
    staleTime: 2 * 60_000,
    retry: false,
  });
}
